var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfigure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 10 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.93934 5.16967H9.40897M0.487061 5.16967H1.47838M1.47838 5.16967C1.47838 5.85403 2.03317 6.40882 2.71754 6.40882C3.4019 6.40882 3.95669 5.85403 3.95669 5.16967C3.95669 4.4853 3.4019 3.93051 2.71754 3.93051C2.03317 3.93051 1.47838 4.4853 1.47838 5.16967ZM8.9133 2.1957H9.40897M0.487061 2.1957H3.95669M7.17849 3.43485C6.49412 3.43485 5.93934 2.88006 5.93934 2.1957C5.93934 1.51133 6.49412 0.956543 7.17849 0.956543C7.86285 0.956543 8.41764 1.51133 8.41764 2.1957C8.41764 2.88006 7.86285 3.43485 7.17849 3.43485Z",
    stroke: "#417EF9",
    strokeWidth: 0.991323,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfigure);
export default __webpack_public_path__ + "static/media/configure.9cc7dc6d4b57ca6c37acb009225395e0.svg";
export { ForwardRef as ReactComponent };